module.exports = __webpack_public_path__ + "media/SetA_L2_B.d8a85bcf.mp3";